type LenisLike = { scrollTo?: (target: number, opts?: { duration?: number }) => void };

export class TopButtonController {
    static init(): void {
        const btns = document.querySelectorAll<HTMLElement>(".top_btn");
        if (btns.length === 0) return;

        btns.forEach((btn) => {
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                const lenis = (window as unknown as { lenis?: LenisLike }).lenis;
                if (lenis?.scrollTo) {
                    lenis.scrollTo(0, { duration: 1.2 });
                } else {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                }
            });
        });
    }
}
